<template>
   <v-col cols="3" class="d-flex justify-begin mb-2">
      <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
              
              </v-col>
    <div><br>
      <div class="scroll-container">
      <table>
       <!--  <caption class="table-header">Compresores</caption> -->
        <thead>
          <tr>
            <th class="encabezado columna_sticky">{{ labels.nombre }}</th>
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.potencia_maxima }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_maxima }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.potencia_minima }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_minima }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.rendimiento_frio_electricidad }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.rendimiento_frio_electricidad }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.estado_inicial_equipo }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.estado_inicial_equipo }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.coste_alquiler }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.coste_alquiler }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.coste_uso }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.coste_uso }}</span>
                </v-tooltip>
            </th> 

          </tr>
        </thead>
        <tbody>
          <tr v-for="(compresor, index) in compresores" :key="index" class="tabla-hover">
            <td class="primera_columna columna_sticky">{{ compresor.nombre }}</td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=compresor.potencia_maxima
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=compresor.potencia_minima
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=compresor.rendimiento_frio_electricidad
                @input="emitChanges"
              />
            </td>
            <td>
              <select v-model="compresor.estado_inicial_equipo" @change="emitChanges" :class="{ 'motor_apagado': compresor.estado_inicial_equipo === 'Parado', 'motor_encendido': compresor.estado_inicial_equipo === 'Encendido' }">
                <option value="Parado">Parado</option>
                <option value="Encendido">Encendido</option>
              </select>
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number="compresor.coste_alquiler"
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number="compresor.coste_uso"
                @input="emitChanges"
              />
            </td>
          </tr>
        </tbody>
      </table>
     </div>
    </div>
  </template>
  
  <script>
  import Swal from 'sweetalert2';

const HEADERS_OFICIALES_COMPRESORES = [
  "Nombre",
  "Potencia máxima",
  "Potencia mínima",
  "Rendimiento frío/electricidad",
  "Estado inicial equipo",
  "Coste alquiler",
  "Coste uso"
];
  export default {
    props: {
      modelValue: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        compresores: Array.isArray(this.modelValue) ? [...this.modelValue] : [],
        labels: {
          nombre: this.$t("planta.planta_compresores"),
          potencia_maxima: this.$t("planta.compresores.potencia_maxima"),
          potencia_minima: this.$t("planta.compresores.potencia_minima"),
          rendimiento_frio_electricidad: this.$t("planta.compresores.rendimiento_frio_electricidad"),
          estado_inicial_equipo: this.$t("planta.compresores.estado_inicial_equipo"),
          coste_alquiler: this.$t("planta.compresores.coste_alquiler"),
          coste_uso: this.$t("planta.compresores.coste_uso"),
        },
        labels_recortado: {
          nombre: this.$t("planta.planta_compresores"),
          potencia_maxima: this.$t("planta.compresores_corto.potencia_maxima"),
          potencia_minima: this.$t("planta.compresores_corto.potencia_minima"),
          rendimiento_frio_electricidad: this.$t("planta.compresores_corto.rendimiento_frio_electricidad"),
          estado_inicial_equipo: this.$t("planta.compresores_corto.estado_inicial_equipo"),
          coste_alquiler: this.$t("planta.compresores_corto.coste_alquiler"),
          coste_uso: this.$t("planta.compresores_corto.coste_uso"),
        },
      };
    },
    watch: {
      modelValue: {
        handler(newValue) {
          this.compresores = Array.isArray(newValue) ? [...newValue] : [];
        },
        deep: true,
      },
    },
    methods: {
      toCsvDecimalComma(v, fixed = null) {
    if (v === null || v === undefined || v === '') return '';
    const n = Number(v);
    if (Number.isNaN(n)) return '';
    const s = fixed != null ? n.toFixed(fixed) : String(n);
    return s.replace('.', ',');
  },
      emitChanges() {
        this.$emit("update:modelValue", this.compresores);
      },
      exportToCSV() {
        try {
          const headers = HEADERS_OFICIALES_COMPRESORES;

          const rows = this.compresores.map(c => [
            c.nombre ?? '',
            this.toCsvDecimalComma(c.potencia_maxima),
            this.toCsvDecimalComma(c.potencia_minima),
            this.toCsvDecimalComma(c.rendimiento_frio_electricidad),
            (c.estado_inicial_equipo === 'Encendido' || c.estado_inicial_equipo === 'Parado') ? c.estado_inicial_equipo : '',
            this.toCsvDecimalComma(c.coste_alquiler),
            this.toCsvDecimalComma(c.coste_uso)
          ].join(';'));

          const csvContent = [headers.join(';'), ...rows].join('\n');
          const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "compresores.csv";
          link.click();
          URL.revokeObjectURL(link.href);

          Swal.fire({ icon: 'success', title: 'Exportación correcta', timer: 1600, showConfirmButton: false });
        } catch (e) {
          Swal.fire({ icon: 'error', title: 'Error al exportar', text: e?.message || 'Revisa los datos.' });
        }
      },

      importFromCSV() {
        this.$refs.fileInput.click();
      },

      handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: 'error', title: 'Formato no válido', text: 'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const content = e.target.result;
      const lines = content.replace(/\r\n/g, '\n').split('\n').filter(Boolean);
      if (lines.length < 2) throw new Error('El CSV está vacío.');

      // ====== Validación de CABECERAS  ======
      let headers = lines[0]
  .split(';')
  .map((h, i) => (i === 0 ? String(h).replace(/^\uFEFF/, '') : String(h)).trim());

// 1) faltantes / extras
const faltantes = HEADERS_OFICIALES_COMPRESORES.filter(h => !headers.includes(h));
const extrasRaw = headers.filter(h => !HEADERS_OFICIALES_COMPRESORES.includes(h));

// limpiar valores vacíos/espacios
const extras = extrasRaw.map(x => String(x).trim()).filter(Boolean);

// 2) desordenadas solo si no hay faltantes ni extras visibles
let desordenadas = [];
if (faltantes.length === 0 && extras.length === 0) {
  HEADERS_OFICIALES_COMPRESORES.forEach((h, i) => {
    if (headers[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
  });
}

// 3) renderizar solo secciones con elementos 
const seccion = (titulo, arr) => {
  const items = (arr || []).map(x => String(x).trim()).filter(Boolean);
  return items.length
    ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4>
       <ul style="margin:0 0 8px 18px; padding:0;">${items.map(x => `<li>${x}</li>`).join('')}</ul>`
    : '';
};

if (faltantes.length || extras.length || desordenadas.length) {
  const html =
    `<div style="text-align:left;">
       <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
       ${seccion('❌ Faltan', faltantes)}
       ${seccion('⚠️ Sobran', extras)}
       ${seccion('🔄 Desordenadas', desordenadas)}
       <p style="margin-top:6px;"><small>
         Consejo: exporta la plantilla oficial y copia tus datos respetando los encabezados y su orden.
       </small></p>
     </div>`;
  Swal.fire({ icon: 'error', title: 'Encabezados incorrectos', html, width: 800 });
  event.target.value = '';
  return;
}
      // ====== Fin validación de CABECERAS ======

      // Índices
      const IDX = {
        nombre: 0,
        pMax: 1,      // Potencia máxima
        pMin: 2,      // Potencia mínima
        rend: 3,      // Rendimiento frío/electricidad
        estado: 4,    // Estado inicial equipo
        cAlq: 5,      // Coste alquiler
        cUso: 6       // Coste uso
      };

      // Helpers
      const raw = (arr, i) => String(arr[i] ?? '').trim();
      const parseNumberStrict = (value) => {
        const s = String(value ?? '').trim();
        if (s === '') return { ok: false, num: NaN };      // vacío => inválido
        const n = this.parseNumber(s);                     // respeta coma/punto
        return { ok: Number.isFinite(n), num: n };
      };

      // errores
      const faltasPorCol = {
        [headers[IDX.nombre]]: [],
        [headers[IDX.pMax]]: [],
        [headers[IDX.pMin]]: [],
        [headers[IDX.rend]]: [],
        [headers[IDX.estado]]: [],
        [headers[IDX.cAlq]]: [],
        [headers[IDX.cUso]]: [],
      };
      const negativosPorCol = {
        [headers[IDX.pMax]]: [],
        [headers[IDX.pMin]]: [],
        [headers[IDX.rend]]: [],
        [headers[IDX.cAlq]]: [],
        [headers[IDX.cUso]]: [],
      };
      const inconsistencias = [];

      const nuevos = [];

      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(';');
        if (cols.every(c => c.trim() === '')) continue; // fila completamente vacía
        if (cols.length !== HEADERS_OFICIALES_COMPRESORES.length) {
          throw new Error(`Fila ${i + 1}: número de columnas inválido (${cols.length}).`);
        }

        const row = i + 1;

        // Lectura 
        const nombre = raw(cols, IDX.nombre);
        const pMaxRaw = raw(cols, IDX.pMax);
        const pMinRaw = raw(cols, IDX.pMin);
        const rendRaw = raw(cols, IDX.rend);
        const estado = raw(cols, IDX.estado);
        const cAlqRaw = raw(cols, IDX.cAlq);
        const cUsoRaw = raw(cols, IDX.cUso);

        // Requeridos 
        if (!nombre) faltasPorCol[headers[IDX.nombre]].push(row);
        if (!pMaxRaw) faltasPorCol[headers[IDX.pMax]].push(row);
        if (!pMinRaw) faltasPorCol[headers[IDX.pMin]].push(row);
        if (!rendRaw) faltasPorCol[headers[IDX.rend]].push(row);
        if (!estado) faltasPorCol[headers[IDX.estado]].push(row);
        if (!cAlqRaw) faltasPorCol[headers[IDX.cAlq]].push(row);
        if (!cUsoRaw) faltasPorCol[headers[IDX.cUso]].push(row);

        // Parseos estrictos
        const { ok: okMax,  num: pMax }  = parseNumberStrict(pMaxRaw);
        const { ok: okMin,  num: pMin }  = parseNumberStrict(pMinRaw);
        const { ok: okRend, num: rend }  = parseNumberStrict(rendRaw);
        const { ok: okAlq,  num: cAlq }  = parseNumberStrict(cAlqRaw);
        const { ok: okUso,  num: cUso }  = parseNumberStrict(cUsoRaw);

        if (pMaxRaw && !okMax)  faltasPorCol[headers[IDX.pMax]].push(row);
        if (pMinRaw && !okMin)  faltasPorCol[headers[IDX.pMin]].push(row);
        if (rendRaw && !okRend) faltasPorCol[headers[IDX.rend]].push(row);
        if (cAlqRaw && !okAlq)  faltasPorCol[headers[IDX.cAlq]].push(row);
        if (cUsoRaw && !okUso)  faltasPorCol[headers[IDX.cUso]].push(row);

        // Negativos NO permitidos
        if (okMax && pMax < 0)  negativosPorCol[headers[IDX.pMax]].push(row);
        if (okMin && pMin < 0)  negativosPorCol[headers[IDX.pMin]].push(row);
        if (okRend && rend <= 0) negativosPorCol[headers[IDX.rend]].push(row); // rendimiento debe ser > 0
        if (okAlq && cAlq < 0)  negativosPorCol[headers[IDX.cAlq]].push(row);
        if (okUso && cUso < 0)  negativosPorCol[headers[IDX.cUso]].push(row);

        // Coherencias
        if (okMax && okMin && pMin > pMax) {
          inconsistencias.push(`Fila ${row}: 'Potencia mínima' no puede superar a 'Potencia máxima'.`);
        }
        if (estado && estado !== 'Encendido' && estado !== 'Parado') {
          inconsistencias.push(`Fila ${row}: 'Estado inicial equipo' debe ser 'Encendido' o 'Parado'.`);
        }

        // Guardamos provisional 
        nuevos.push({
          nombre,
          potencia_maxima: okMax ? pMax : null,
          potencia_minima: okMin ? pMin : null,
          rendimiento_frio_electricidad: okRend ? rend : null,
          estado_inicial_equipo: estado || null,
          coste_alquiler: okAlq ? cAlq : null,
          coste_uso: okUso ? cUso : null
        });
      }

      // Consolidar errores 
      const colsFaltas = Object.entries(faltasPorCol).filter(([, arr]) => arr.length);
      const colsNeg    = Object.entries(negativosPorCol).filter(([, arr]) => arr.length);

      if (colsFaltas.length || colsNeg.length || inconsistencias.length) {
        const bloques = [];
        if (colsFaltas.length) {
          const htmlF = colsFaltas.map(([col, arr]) =>
            `• <b>${col}</b>: líneas <b>${arr.slice(0, 12).join(', ')}${arr.length > 12 ? '…' : ''}</b>`
          ).join('<br>');
          bloques.push(`<h4 style="margin:8px 0 4px 0;">Faltan datos obligatorios</h4>${htmlF}`);
        }
        if (colsNeg.length) {
          const htmlN = colsNeg.map(([col, arr]) =>
            `• <b>${col}</b>: líneas <b>${arr.slice(0, 12).join(', ')}${arr.length > 12 ? '…' : ''}</b>`
          ).join('<br>');
          bloques.push(`<h4 style="margin:8px 0 4px 0;">Valores inválidos</h4>${htmlN}`);
        }
        if (inconsistencias.length) {
          bloques.push(
            `<h4 style="margin:8px 0 4px 0;">Inconsistencias</h4>
             <ul style="margin:0 0 8px 18px; padding:0;">${inconsistencias.map(m => `<li>${m}</li>`).join('')}</ul>`
          );
        }

        Swal.fire({
          icon: 'error',
          title: 'Errores en datos',
          html: `<div style="text-align:left; max-height:50vh; overflow:auto;">${bloques.join('<br>')}</div>`,
          width: 820
        });
        event.target.value = '';
        return; // bloquear importación
      }

      // Aplicar si no hay errores
      this.compresores = nuevos;
      this.emitChanges();
      Swal.fire({ icon: 'success', title: 'Importación correcta', text: `${nuevos.length} registros importados.` });

    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      event.target.value = ''; // limpia el input
    }
  };

  reader.readAsText(file, 'utf-8');
},

      parseNumber(value) {
      if (!value) return 0;

      
      value = value.trim();

      
      if (value.includes(',') && !value.includes('.')) {
        value = value.replace(/\./g, '');        
        value = value.replace(',', '.');          
      }

      
      else if (value.includes(',') && value.includes('.')) {
        
        if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
          value = value.replace(/\./g, '');       
          value = value.replace(',', '.');      
        }
        
        else {
          value = value.replace(/,/g, '');        
        }
      }

      

      return parseFloat(value);
    },
      /*
      formatDecimal(value) {
        return value ? parseFloat(value).toFixed(2) : "0.00";
      },

      // Función para actualizar valores con redondeo 
      updateCompresor(index, key, value) {
        const newValue = parseFloat(parseFloat(value).toFixed(2)); // Convierte a número y redondea

        this.compresores = Object.assign([], this.compresores, { [index]: { ...this.compresores[index], [key]: newValue } });

        // Emitir cambios al padre
        this.$emit("update:modelValue", [...this.compresores]);
      },*/
    },
  };
  </script>
  
  <style scoped>

  table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
    /* Contenedor con scroll horizontal y vertical */
    .scroll-container {
      width: 100%;
      height: 100%;
      max-height: calc(100vh - 200px); 
      overflow-x: auto;
      overflow-y: auto;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
    }
  thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }
  .table-header {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
  }



  
  input[type="number"] {
    width: 100%;
    text-align: center;
    border: none;
    border-radius: 4px;
    color: #024e74;
  }
  
  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #024e74;
  }
  
  input[disabled] {
    background-color: #f2f2f2;
    color: #024e74;
    cursor: not-allowed;
  }
  </style>
  